import React from 'react';
import HiddenInput from 'shared/components/HiddenInput';

const ColumnSelected = (props) => {
  const { parameters } = props;
  const name = 'column_selected';
  let value = parameters[name];

  if (value !== undefined && typeof value === 'number') {
    value = value.toString();
  }
  return (
    <HiddenInput name={name} value={value === undefined ? '' : value} />
  );
};

export default ColumnSelected;
